import { useEffect, useRef, useState } from 'react';

// Largura de um elemento, atualizada quando a tela muda de tamanho
export default function useLargura<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  const [largura, setLargura] = useState(0);

  useEffect(() => {
    const elemento = ref.current;
    if (!elemento) return;

    setLargura(elemento.clientWidth);
    const observador = new ResizeObserver(([entrada]) => setLargura(Math.floor(entrada.contentRect.width)));
    observador.observe(elemento);

    return () => observador.disconnect();
  }, []);

  return { ref, largura };
}
